export const SET_SIDEBAR_VISIBILITY = 'SET_SIDEBAR_VISIBILITY';
